var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"skeleton"},[_c('div',{staticClass:"loader centered-absolute"},[_c('svg',{staticClass:"circular-loader",attrs:{"viewBox":"25 25 50 50"}},[_c('circle',{staticClass:"loader-path",attrs:{"cx":"50","cy":"50","r":"20","fill":"none","stroke":"#70c542","stroke-width":"3"}})])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }